import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { DataTable } from "@/components/DataTable";
import { IConsultantProfile } from "@/data/consultant-profiles";
import { formatFullName } from "@/data/persons";

export interface AssignmentRelatedConsultantsTableProps {
  consultantProfile: IConsultantProfile;
  onRowClick?: (consultantProfile: IConsultantProfile) => void;
}

export const AssignmentRelatedConsultantsTable: FC<AssignmentRelatedConsultantsTableProps> = memo(
  ({ consultantProfile, onRowClick }) => {
    const { t } = useTranslation("session");

    return (
      <DataTable<IConsultantProfile>
        onRowClick={onRowClick}
        data={[consultantProfile]}
        columns={[
          {
            header: "",
            selector: () => null,
            flexGrow: 1,
            maxWidth: "100px",
          },
          {
            header: t("ASSIGNMENTS.DETAILS.RELATED_DETAILS.CONSULTANTS.NAME_TABLE_HEADER"),
            selector: (data: IConsultantProfile) => formatFullName(data),
            flexGrow: 1,
          },
          {
            header: t("ASSIGNMENTS.DETAILS.RELATED_DETAILS.CONSULTANTS.EMAIL_TABLE_HEADER"),
            selector: (data: IConsultantProfile) => data.email,
            flexGrow: 1,
            maxWidth: "300px",
          },
        ]}
        uniqueKeyAccessor="id"
      />
    );
  },
);
